import { render, staticRenderFns } from "./AddContact.vue?vue&type=template&id=2e86a494&"
import script from "./AddContact.vue?vue&type=script&lang=js&"
export * from "./AddContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports